export default class Cell{
    constructor(cell){
        this.name = cell.name;
        this.number = cell.number;
        this.text = cell.text;
        this.style = cell.style;
        this.custom_style = cell.custom_style;
        this.workCenterId = cell.workCenterId;
        this.other = cell.other;
        this.suppliers = cell.suppliers;
        this.related_supplier = cell.related_supplier;
        this.date_cell = cell.date_cell
    }
} 